import type { User } from '../types/auth';
import type { ShipmentContract } from '../types/marketplace';

export function normalizeInvitationStatus(status: string): 'pending' | 'accepted' | 'declined' {
    if (status === 'pending' || status === 'invited') {
        return 'pending';
    }

    if (status === 'accepted') {
        return 'accepted';
    }

    return 'declined';
}

export function resolveMyParticipationStatus(
    contract: ShipmentContract,
    userId: number,
    userEmail: string,
): 'pending' | 'accepted' | 'none' {
    const participantStatus = contract.participants?.find((participant) => participant.user_id === userId)?.status;
    if (participantStatus === 'pending' || participantStatus === 'accepted') {
        return participantStatus;
    }

    const invitationStatus = contract.invitations
        ?.find((invitation) => (
            (invitation.invited_user_id !== null && invitation.invited_user_id === userId)
            || invitation.email.trim().toLowerCase() === userEmail.trim().toLowerCase()
        ))
        ?.invite_status;

    if (invitationStatus) {
        const normalizedStatus = normalizeInvitationStatus(invitationStatus);
        if (normalizedStatus === 'pending' || normalizedStatus === 'accepted') {
            return normalizedStatus;
        }
    }

    return 'none';
}

export function isContractVisibleToUser(contract: ShipmentContract, user: User | null | undefined): boolean {
    if (!user) {
        return true;
    }

    const isOwner = contract.client_user_id === user.id || contract.operator_user_id === user.id;
    if (isOwner) {
        return true;
    }

    return resolveMyParticipationStatus(contract, user.id, user.email) !== 'pending';
}